
export function TDSleekBox({children}) {
    return <div className="rules-box">{children}</div>
}
export function TDBullet({ style, className }) {
    return <img src='/Icons/UI/BulletPoint3.png' style={style} className={`rules-toc-h3-bullet ` + className}/>
}
export function TDSleek1({children}) {
    return <div className='rules-toc-h1'>{children}</div>
}
export function TDSleek2({children}) {
    return <div className='rules-toc-h2'>{children}</div>
}
export function TDSleek3({children}) {
    return <div className='rules-toc-h3'>{children}</div>
}